import { observable, override } from 'mobx';
import { periodTypes } from '@/store/mapping';

export default class TaxpayersControlStore {
  @override @observable period = '';
  @override @observable periodType = 'date';
  @override @observable periodTypes = periodTypes;
  @override @observable incomeTaxesMode = 'income';
}
